import "./styles/global.css";

import Navbar          from "./components/Navbar";
import Footer          from "./components/Footer";
import HeroSection     from "./sections/HeroSection";
import AboutSection    from "./sections/AboutSection";
import ExperienceSection from "./sections/ExperienceSection";
import ProjectsSection from "./sections/ProjectsSection";
import StackSection    from "./sections/StackSection";
import ContactSection  from "./sections/ContactSection";
import RecommendationsSection from "./sections/RecommendationsSection";

/**
 * Scrolls smoothly to any section by id.
 * Shared utility passed down as a prop to avoid duplication.
 */
const scrollTo = (id) => {
  document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: "smooth" });
};

function App() {
  return (
    <div style={{ fontFamily: "'IBM Plex Mono', monospace", background: "#ffffff", color: "#0f1724", minHeight: "100vh" }}>
      <Navbar scrollTo={scrollTo} />

      <HeroSection scrollTo={scrollTo} />
      <hr className="div" />

      <AboutSection />
      <hr className="div" />

      <ExperienceSection />
      <hr className="div" />

      <ProjectsSection />
      <hr className="div" />

      <StackSection />
      <hr className="div" />

      <RecommendationsSection />
      <hr className="div" />

      <ContactSection />

      <Footer />
    </div>
  );
}

export default App;